import {
    clinicSqbOrderPay,
    bindMiniPatientIdentity,
    clinicSqbQueryResult,
    getDicts,
    getMedicalOrderDetail,
    getMedicalOrderPaymentReceipt,
    getMiniOrderIdentityReservations
} from "@/api";
import baseConfig from "@/api/config";
import {message} from "@/assets/utils/common";
import {ElMessageBox} from "element-plus";
import officialAccountQrCode from "@/assets/images/official-account-qrcode.jpg";
import {getDecoctionName, refreshDecoctionNameMap} from "@/assets/utils/decoction";

/**
 * pending 自动轮询窗口（秒）。取 150s 的两条约束：
 * ① 不得大于后端扫码支付锁的 TTL（ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）——
 *    窗口先到点而锁还在，会出现「页面已转待人工核查、收银员想重扫却被锁挡住」的自相矛盾状态；
 * ② 必须盖住后端补查阶梯 —— pending 落地时距发起已约 60s（SCAN_REQUEST_BUDGET_MS），
 *    两跳补查（间隔 +30s / +60s）落在 pending 落地后 +30s / +90s（即发起后约 +90s / +150s）；
 *    窗口从 pending 回包起算，留 60s 余量；到点后后端已有最终结论（收敛落库或自动撤单），收银员可放心关闭。
 */
const PAY_PENDING_WINDOW_SECONDS = 150;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    props: {
        orderId: ""
    },
    data() {
        return {
            userInfo: null,
            headImg: "",
            sysName: "",
            medicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                docPatientCaseId: null, // 关联的病历ID
                conId: null,
                serialNo: null,
                docPrice: "0.00", //诊费
                clinicalDiagnosis: null, // 诊断结果
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientPhone: null,
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientIdentity: null, // 患者身份证
                oldOrderId: null,
                linkDoctorInfo: null,
                hasLinkDoctor: false,
                takeWay: "0",
                viceNum: "7", //药品副数
                // docAdvice: '每日一副 分两次服用（开水冲化 温服）',  //医嘱
                docAdvice: '开水温服',
                orderWeight: "0", // 药材总重
                medicalCountPrice: "0.00", //药材费用
                processingCosts: "0.00", //加工费用
                orderPrice: "0.00", //总价
                instructions: null,
                smsPhone: "",
                adjustmentPrice: "0.00",// 调理价格
                discountPrice: "0.00", // 优惠金额
                freeCasePic: "", // 科研药方的图片
                isFree: "1",
                dayTakeNum: "1", //X日一剂
                takeTimes: "2", // 每日分X次服用/每日X次
                timeUseNum: "1", // 每次XX克、XX毫升
                packWay: "0", // 包装方式 （0袋装 1瓶装）
                useWay: null, // 医嘱用法
                useAttention: null, // 医嘱禁忌
                fuCountPrice: 0,  // 辅药药品费用
                decoctType: '0', // 煎煮方式  0=自煎,1=代煎
                specification: '200', // 煎煮规格 规格 200ml/100ml
                orderMedicineFuList: [],  //辅药列表（和药品列表一样传参）
                completeTime: "",
                cancelTime: "",
                payTime: "",
            },
            doctorInfo: {
                docPrice: null,
                docPriceRate: null,
                docPriceWay: 0,
                docFreeOpen: "",
                docPriceHide: "0",
            },
            dictOrderStatus: 'sys_order_status',
            dictOrderStatusList: [],

            prescriptionPaperDialogDialogVisible: false, // 处方笺预览弹窗
            printDate: null, // 打印日期
            payCodeList: [], // 预览的支付码
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            showOrderMedicineFuList: "",
            detailLoading: false,

            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部处方笺', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部处方笺', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            isMiniProgramOrder: false,
            needsIdentityBinding: false,
            miniIdentityOptions: [],
            selectedMiniIdentity: '',
            manualMiniIdentity: '',
            miniIdentityQueryCompleted: false,
            miniIdentityLoading: false,
            miniIdentitySaving: false,
            miniIdentitySaved: false,
            miniIdentityError: '',
            miniIdentityRequestId: 0,
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: true, // 订单收费等待扫码
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payState: "", // 收款三态：''（未发起）/ success / pending（结果确认中）/ failed
            payChannel: "", // 收款渠道：SQB（收钱吧）/ CASH（现金）/ FREE（免费单）
            payRequesting: false, // 支付请求在途（防止重复扫码发起第二个请求）
            querying: false, // 「重新查询」在途（手动与自动轮询共用，只作并发去重）
            manualQuerying: false, // 手动「重新查询」在途：只有它会锁弹窗，自动轮询不锁
            listQuerying: false, // 列表行「查询收款结果」进行中
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            removeScanListener: null, // 用于存储移除扫码监听器的函数
            receiptLoading: false,
            receiptPreviewVisible: false,
            receiptPrintTime: '',
            paymentReceipt: {
                institutionName: null,
                patientName: null,
                patientAge: null,
                patientGender: null,
                prescriptionType: null,
                doseCount: null,
                receivedAmount: null,
                orderNo: null,
                paidAt: null,
                paymentMethod: null,
                promotion: null
            },
            receiptPromotionImageError: {
                officialAccount: false
            },
            receiptPrintInfoObj: {
                id: 'paymentReceiptPrintArea',
                popTitle: '门诊收款凭证',
                previewTitle: '门诊收款凭证预览',
                extraHead: '<style>@page{size:80mm auto;margin:4mm}.payment-receipt-print{box-sizing:border-box;width:72mm;padding:3mm 2.5mm;color:#111;font-family:"Microsoft YaHei",SimSun,sans-serif;font-size:10pt;line-height:1.5}.receipt-title,.receipt-name,.receipt-subtitle,.receipt-footer,.receipt-barcode-section,.receipt-promotion-title{text-align:center}.receipt-title{font-size:13pt;font-weight:bold;line-height:1.4}.receipt-name{margin-top:1mm;font-size:15pt;font-weight:bold}.receipt-subtitle{margin:.5mm 0 2mm;padding-bottom:2mm;border-bottom:1px solid #111;color:#666;font-size:8pt;letter-spacing:.7px}.receipt-section{padding:1.8mm 0;border-bottom:1px dashed #777}.receipt-section-title{margin-bottom:1mm;font-size:9pt;font-weight:bold}.receipt-payment-title{margin-top:1.8mm}.receipt-row{display:flex;justify-content:space-between;gap:4mm;min-height:5mm}.receipt-row span:last-child{text-align:right;word-break:break-all;font-weight:500}.receipt-amount{display:flex;justify-content:space-between;align-items:center;margin:1.5mm 0;padding:2mm;background:#f3f4f6;font-weight:bold}.receipt-amount strong{font-size:13pt}.receipt-barcode-section{padding:2mm 0;border-bottom:1px dashed #777;font-size:9pt;font-weight:bold}.receipt-barcode-section svg{display:block;width:60mm;height:17mm;margin:1.5mm auto}.receipt-order-no{font-size:9pt;letter-spacing:1px}.receipt-hint,.receipt-footer small,.receipt-promotion-list small{color:#555;font-size:8pt;font-weight:normal}.receipt-promotion-section{padding:2mm 0;border-bottom:1px dashed #777;text-align:center}.receipt-promotion-title{font-size:9pt;font-weight:bold}.receipt-promotion-list{display:flex;justify-content:center;margin-top:1.5mm}.receipt-promotion-list>div{width:58mm;font-size:9pt;font-weight:bold;white-space:nowrap}.receipt-promotion-list img{display:block;width:32mm;height:32mm;margin:0 auto 1mm;object-fit:contain}.receipt-print-time{border-bottom:1px solid #111}.receipt-footer{padding-top:2mm;font-size:9pt}</style>',
                preview: false,
                beforeOpenCallback() {},
                openCallback() {},
                closeCallback() {},
                url: '',
                standard: 'html5',
                extraCss: ''
            },
            decoctionNameMap: {}
        }
    },

    created() {
        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList = res.data.data;
        });

        refreshDecoctionNameMap().then(map => {
            this.decoctionNameMap = map;
        }).finally(() => this.getMedicalOrderDetailInfo());

        console.log("this.orderId");
        console.log(this.orderId);
        this.getMedicalOrderDetailInfo();
    },
    mounted() {
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.initScanListener();
    },
    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        // 如果存在移除监听器的函数，则调用它
        this.stopPayPendingWatch();
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    computed: {
        // 结果面板主文案：必须与后端三态/渠道一致，pending 不得渲染成失败
        payResultText() {
            if (this.payState === 'success') {
                if (this.payChannel === 'CASH') {
                    return '已现金收款';
                }
                if (this.payChannel === 'FREE') {
                    return '为免费单，无需支付';
                }
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                // 窗口到点后转「待人工核查」：仍是「未确认」，绝不能说成失败
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        },
        // 只有收钱吧渠道才允许打印收钱吧凭证（AC6）
        canPrintSqbReceipt() {
            return this.isPayed && this.payState === 'success' && this.payChannel === 'SQB';
        },
        // 只锁「请求在途」：支付请求受 axios 70s 超时封顶、手动重查是单次查单耗时，故不可关闭时长上限≈70s。
        // pending 期间放行关闭（结果未定时关窗确实会诱导重扫，但收银员不能被关在只能干等的弹窗里）——
        // 关窗后仍有列表「查询收款结果」、服务端补查阶梯与日终对账三层兜底。
        // 用 manualQuerying 而不是 querying：后者被 10s 自动轮询共用，直接锁会让弹窗每 10 秒闪一下。
        payDialogLocked() {
            return this.payRequesting || this.manualQuerying;
        },
    },
    methods: {
        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading && (!this.isMiniProgramOrder || this.miniIdentitySaved)) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            // AC12：请求在途时再次扫码不得发起第二个请求（重复扣款风险）
            if (this.payRequesting) {
                console.warn("上一笔支付请求尚未返回，忽略本次扫码");
                return;
            }
            console.log("orderId >>>>" + this.medicalOrder.orderId);
            console.log("orderPrice >>>>" + this.medicalOrder.orderPrice);
            console.log("dynamicId >>>>" + dynamicId);
            this.payRequesting = true;
            // 新一次扫码：结束上一轮 pending 窗口
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            this.payLoading = true;
            this.isPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            let params = {
                orderId: this.medicalOrder.orderId,
                price: this.medicalOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            clinicSqbOrderPay(JSON.stringify(params)).then(response => {
                console.log(response);
                this.applyPayResult(response, false);
            }).catch(error => {
                console.error('支付请求失败:', error);
                message("支付请求失败", "error");
                // AC13：异常必须复位，弹窗不得卡在等待态
                this.payLoading = false;
                this.isWaitPayLoading = true;
                this.isPayed = false;
                this.payState = "";
                this.payChannel = "";
            }).finally(() => {
                this.payRequesting = false;
            });
        },

        /**
         * 按后端三态契约渲染收款结果：
         *   code=200 + data.payState=success + data.channel  → 已收款（渠道见 payChannel）
         *   code=601 + data.payState=pending                 → 结果确认中，既非成功也非失败
         *   其余                                             → 明确失败
         *
         * 不能只看 code 是否为 200 就判成功，也不能把 601 当失败 —— 后者会诱导收银员重扫。
         */
        async applyPayResult(response, silent) {
            this.isWaitPayLoading = false;
            this.payLoading = false;
            this.isPayed = true;
            this.payErrorMsg = "";
            // POST resolve 的是 response.data（带 code/msg/data），GET 查单 resolve 的是完整 axios response，先归一化
            const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
            const data = (payload && payload.data) || {};
            const payState = data.payState;
            const channel = data.channel || "";

            if (payload && payload.code === 200 && payState === 'success') {
                this.payState = 'success';
                this.payChannel = channel;
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                message(this.paySuccessText(channel), "success");
                // AC6：现金收款 / 免费单不得打印收钱吧凭证
                if (channel !== 'SQB') {
                    this.resetReceipt();
                    return;
                }
                try {
                    await this.getMedicalOrderDetailInfo();
                    await this.$nextTick();
                    this.openPaymentReceipt(false);
                } catch (error) {
                    console.error('支付成功后的订单详情刷新失败:', error);
                    message("支付成功，但订单详情刷新失败，请手动打印凭证", "warning");
                }
            } else if (payload && payload.code === 601 && payState === 'pending') {
                // AC3：第三态。既不得显示成功，也不得显示失败。
                this.payState = 'pending';
                this.payChannel = "";
                this.successPayed = false;
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    // 首次进入 pending：开自动轮询窗口（与后端支付锁 TTL 对齐）
                    this.startPayPendingWatch();
                }
                this.payErrorMsg = this.payPendingExpired
                    ? this.pendingExpiredMessage()
                    : this.pendingMessage();
                if (!silent) {
                    message("支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = "";
                this.successPayed = false;
                this.payErrorMsg = (payload && payload.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
        },

        // 收款渠道对应的成功文案（AC5 / AC6：免费单、现金收款不得说成「收钱吧支付成功」）
        paySuccessText(channel) {
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // AC3：pending 态的「重新查询」。走只读查单接口，绝不会发起扣款，可安全重复点击。
        requeryPayResult(silent) {
            if (this.querying || !this.medicalOrder.orderId) {
                return;
            }
            this.querying = true;
            if (!silent) {
                // 只有手动重查锁弹窗；自动轮询不锁，否则 pending 期间弹窗每 10 秒闪一下
                this.manualQuerying = true;
            }
            //silent=true 就是自动轮询（弹窗每 10 秒一次）：把它作为 autoPoll 传给后端，
            //让「机器在等」与「收银员点了一次」在查单留痕里可区分
            clinicSqbQueryResult(this.medicalOrder.orderId, !!silent).then(response => {
                this.applyPayResult(response, silent);
            }).catch(error => {
                console.error('重新查询支付结果失败:', error);
                if (!silent) {
                    message("重新查询失败，请稍后重试", "error");
                }
            }).finally(() => {
                this.querying = false;
                this.manualQuerying = false;
            });
        },

        // 列表行「查询收款结果」：弹窗关闭后仍可从这里补查。只读查单，绝不发起扣款。
        // autoPoll 传 false：后端据此把留痕记成 manual（只有弹窗自动轮询才传 true）。
        queryListPayResult(row) {
            if (this.listQuerying || !row.orderId) {
                return;
            }
            this.listQuerying = true;
            clinicSqbQueryResult(row.orderId, false).then(response => {
                const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
                const data = (payload && payload.data) || {};
                if (payload && payload.code === 200 && data.payState === 'success') {
                    message("该订单已通过收钱吧支付", "success");
                    this.getOrderList();
                } else if (payload && payload.code === 601 && data.payState === 'pending') {
                    //601 是正常业务态，绝不能报 error —— 报错会诱导收银员重扫
                    message("收款结果仍未确认，请稍后再查", "warning");
                } else {
                    //含「该订单尚未发起过扫码支付，无法查询支付结果」，原样透出后端文案
                    message((payload && payload.msg) || "查询收款结果失败", "error");
                }
            }).catch(error => {
                console.error('查询收款结果失败:', error);
                message("查询收款结果失败，请稍后重试", "error");
            }).finally(() => {
                this.listQuerying = false;
            });
        },

        /**
         * 开始 pending 自动轮询：每 PAY_PENDING_POLL_INTERVAL_SECONDS 秒查一次只读查单接口，
         * 最长 PAY_PENDING_WINDOW_SECONDS 秒；到点转「待人工核查」。
         *
         * 窗口到点时后端补查阶梯已跑完（pending 落地 +90s 的自动撤单已释放支付锁；若补查没排上，
         * 锁会保留到 10 分钟 TTL），收银员可重新扫码 —— 重扫会先经后端 checkPreviousScanOrder：
         * 上一笔已 PAID 则直接报成功，仍是未定态则被保守拦截，因此「放行重扫」不会造成重复扣款。
         */
        startPayPendingWatch() {
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            this.payPendingTimer = setInterval(() => {
                // 状态已被其他路径改写（成功/失败/重置）时窗口自行结束，
                // 这样各处的重置逻辑不必逐个记得清定时器
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired();
                    return;
                }
                this.payErrorMsg = this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    // 自动轮询不弹 toast，避免每 10 秒打扰收银员一次
                    this.requeryPayResult(true);
                }
            }, 1000);
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        // 窗口到点：转「待人工核查」。绝不能说成「支付失败」—— 钱可能已经收了。
        markPayPendingExpired() {
            this.payPendingExpired = true;
            this.payErrorMsg = this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            return "支付结果超过 " + PAY_PENDING_WINDOW_SECONDS + " 秒仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },


        getOrderStatus(dictCode) {
            return this.getDictValue(dictCode, this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },

        // 获取订单详情信新
        getMedicalOrderDetailInfo() {
            console.log(this.orderId);
            this.detailLoading = true;
            return getMedicalOrderDetail(this.orderId).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.detailLoading = false;
                    this.patientInfo = response.data.data.patientInfo;
                    if (this.patientInfo.sex === "1") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                    } else if (this.patientInfo.sex === "0") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                    } else {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                    }
                    this.doctorInfo = response.data.data.doctorInfo;
                    console.log("response.data.data.docPriceHide");
                    console.log(this.doctorInfo);
                    if (this.doctorInfo.docPrice === null || this.doctorInfo.docPrice === undefined || this.doctorInfo.docPrice === '') {
                        this.doctorInfo.docPrice = "0";
                    }
                    if (this.doctorInfo.docPriceRate === null || this.doctorInfo.docPriceRate === undefined || this.doctorInfo.docPriceRate === '') {
                        this.doctorInfo.docPriceRate = "0";
                    }
                    if (this.doctorInfo.docPriceHide === null || this.doctorInfo.docPriceHide === undefined || this.doctorInfo.docPriceHide === '') {
                        this.doctorInfo.docPriceHide = "0";
                    }
                    console.log(this.doctorInfo.docPriceHide);
                    this.medicalOrder = response.data.data.medicalOrder;
                    this.isMiniProgramOrder = ['patient', 'patientRepeat', 'doc', 'docRepeat'].includes(this.medicalOrder.orderSource);
                    if (this.medicalOrder.docAdvice === null) {
                        this.medicalOrder.docAdvice = '每日一副 分两次服用（开水冲化 温服）';
                    }
                    if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                        this.medicalOrder.picUrl = this.tencentCosUrl + this.medicalOrder.picUrl;
                    }
                    this.payCodeList = [];
                    this.payCodeList.push(this.tencentCosUrl+this.medicalOrder.payQrcode);
                    if (this.medicalOrder.takeWay === "null" || this.medicalOrder.takeWay === null) {
                        this.medicalOrder.takeWay = "0";
                    }
                    if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this
                        .medicalOrder.viceNum === "") {
                        this.medicalOrder.viceNum = "1";
                    }
                    this.indexMedicine = this.medicalOrder.billingType === null ? '0' : this.medicalOrder.billingType;
                    this.indexeat = parseInt(this.medicalOrder.takeWay === null ? '0' : this.medicalOrder.takeWay);
                    this.indexSex = parseInt(this.medicalOrder.patientSex === null ? '0' : this.medicalOrder.patientSex);

                    this.medicalOrder.packWay = this.medicalOrder.packWay === null ? '0' : this.medicalOrder.packWay;

                    this.medicalOrder.dayTakeNum = this.medicalOrder.dayTakeNum === null ? '1' : this.medicalOrder.dayTakeNum;//X日一剂
                    this.medicalOrder.takeTimes = this.medicalOrder.takeTimes === null ? '2' : this.medicalOrder.takeTimes;// 每日分X次服用/每日X次
                    this.medicalOrder.timeUseNum = this.medicalOrder.timeUseNum === null ? '1' : this.medicalOrder.timeUseNum;// 每次XX克、XX毫升

                    this.docMedicineArray = [];
                    var orderMedicineList = this.medicalOrder.orderMedicineList;
                    console.log("orderMedicineList");
                    console.log(orderMedicineList);
                    if (orderMedicineList !== null) {
                        orderMedicineList.forEach(melist => {
                            let decoctWay = melist.decoctWay;
                            let decoctionName = getDecoctionName(decoctWay, this.decoctionNameMap);
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.medicinePrice,
                                gCount: melist.countNum,
                                newGCount: melist.newGCount,
                                meRemark: melist.meDesc,
                                mCount: melist.totalPrice,
                                decoctionId: decoctWay,
                                decoctionName: decoctionName,
                                drugProperty: melist.drugProperty
                            });
                        })
                    }

                    this.chooseFuliaoList = [];
                    var orderMedicineFuList = this.medicalOrder.orderMedicineFuList;
                    console.log("orderMedicineFuList");
                    console.log(orderMedicineFuList);
                    if (orderMedicineFuList !== null) {
                        orderMedicineFuList.forEach(melist => {
                            this.chooseFuliaoList.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                meDesc: melist.meDesc,
                                price: melist.price,
                                meCount: melist.countNum,
                                countPrice: melist.totalPrice
                            });
                        })
                    }

                    if (this.docMedicineArray.length > 0) {
                        this.docMedicineArray.forEach(docMedlist => {
                            docMedlist.decoctWay = docMedlist.decoctionId;
                        });
                        this.medicalOrder.orderMedicineList = this.docMedicineArray;
                    }
                    // this.reCount();
                } else {
                    this.detailLoading = false;
                    message(response.data.msg, 'error');
                    throw new Error(response.data.msg || '订单详情获取失败');
                }
            });

        },


        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
            this.needsIdentityBinding = ['patient', 'patientRepeat', 'doc', 'docRepeat'].includes(this.medicalOrder.orderSource) && !String(this.medicalOrder.patientIdentity || this.patientInfo.identity || '').trim();
            this.isWaitPayLoading = !this.needsIdentityBinding;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            this.isMiniProgramOrder = ['patient', 'patientRepeat', 'doc', 'docRepeat'].includes(this.medicalOrder.orderSource);
            this.miniIdentityOptions = [];
            this.selectedMiniIdentity = '';
            this.manualMiniIdentity = '';
            this.miniIdentityQueryCompleted = false;
            this.miniIdentityError = '';
            this.miniIdentityRequestId++;
            this.miniIdentityLoading = false;
            this.miniIdentitySaved = !this.needsIdentityBinding;
            if (this.needsIdentityBinding) this.loadMiniOrderIdentityOptions();
            this.resetReceipt();
        },

        async loadMiniOrderIdentityOptions() {
            if (this.miniIdentitySaving || this.miniIdentityLoading) return;
            this.miniIdentityLoading = true;
            this.miniIdentityQueryCompleted = false;
            const requestId = ++this.miniIdentityRequestId;
            this.miniIdentityError = '';
            try {
                const response = await getMiniOrderIdentityReservations(this.medicalOrder.orderId);
                if (requestId !== this.miniIdentityRequestId || !this.orderPayDialogVisible) return;
                if (!response.data || response.data.code !== 200 || !Array.isArray(response.data.data)) {
                    throw new Error((response.data && response.data.msg) || '预约信息查询失败');
                }
                this.miniIdentityQueryCompleted = true;
                const seen = new Set();
                this.miniIdentityOptions = response.data.data.filter(row => {
                    if (!row.cardIdentity || seen.has(row.cardIdentity)) return false;
                    seen.add(row.cardIdentity);
                    return true;
                });
                this.selectedMiniIdentity = this.miniIdentityOptions.length ? this.miniIdentityOptions[0].reId : '';
            } catch (error) {
                if (requestId !== this.miniIdentityRequestId) return;
                this.miniIdentityError = '预约信息查询失败，请重试';
            } finally {
                if (requestId === this.miniIdentityRequestId) this.miniIdentityLoading = false;
            }
        },

        async confirmMiniPatientIdentity() {
            if (this.miniIdentitySaving || this.miniIdentityLoading) return;
            if (!this.miniIdentityQueryCompleted || this.miniIdentityError) {
                message('请先完成预约信息查询', 'warning');
                return;
            }
            const manual = this.miniIdentityOptions.length === 0;
            const identity = String(this.manualMiniIdentity || '').trim().toUpperCase();
            if (manual && !/^\d{17}[\dX]$/.test(identity)) {
                message('请输入18位有效身份证号码', 'warning');
                return;
            }
            if (!manual && !this.selectedMiniIdentity) {
                message('请选择预约人身份证信息', 'warning');
                return;
            }
            const payload = {orderId: this.medicalOrder.orderId};
            if (manual) payload.patientIdentity = identity;
            else payload.reservationId = this.selectedMiniIdentity;
            this.miniIdentitySaving = true;
            const requestId = this.miniIdentityRequestId;
            try {
                const response = await bindMiniPatientIdentity(payload);
                if (requestId !== this.miniIdentityRequestId || !this.orderPayDialogVisible) return;
                if (response && response.code === 200) {
                    const selected = this.miniIdentityOptions.find(row => row.reId === this.selectedMiniIdentity);
                    const savedIdentity = (response.data && response.data.patientIdentity) || (manual ? identity : selected.cardIdentity);
                    this.patientInfo.identity = savedIdentity;
                    this.medicalOrder.patientIdentity = savedIdentity;
                    if (response.data && response.data.patientId) {
                        this.patientInfo.patientId = response.data.patientId;
                        this.medicalOrder.patientId = response.data.patientId;
                    }
                    this.miniIdentitySaved = true;
                    message('患者身份证已关联订单', 'success');
                } else {
                    message((response && response.msg) || '患者身份证关联失败', 'error');
                }
            } catch (error) {
                if (requestId === this.miniIdentityRequestId) message('患者身份证关联失败，请稍后重试', 'error');
            } finally {
                if (requestId === this.miniIdentityRequestId) this.miniIdentitySaving = false;
            }
        },

        startMiniOrderPayment() {
            if (this.isMiniProgramOrder && !this.miniIdentitySaved) {
                message('请先确认并关联患者身份证信息', 'warning');
                return;
            }
            this.isWaitPayLoading = true;
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            this.getMedicalOrderDetailInfo();
            this.resetReceipt();
        },


        // 打印待支付单据
        printPayInfo() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
        },


        // 取消支付
        cancalPay() {
            // 等待期（请求在途 / 结果确认中）不允许关闭：结果未定时关窗会诱导收银员重扫，
            // 而扣款可能已经发生。此处同时兜住 X、点遮罩、ESC 与「取消」按钮四条关闭路径。
            if (this.payDialogLocked) {
                message("查询支付结果中，请勿关闭弹窗", "warning");
                return;
            }
            if (this.miniIdentitySaving) {
                message('正在关联患者信息，请稍候', 'warning');
                return;
            }
            this.miniIdentityRequestId++;
            this.miniIdentityLoading = false;
            this.orderPayDialogVisible = false;
            this.isMiniProgramOrder = false;
            this.miniIdentitySaved = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            this.resetReceipt();
        },

        resetReceipt() {
            this.receiptLoading = false;
            this.receiptPreviewVisible = false;
            this.receiptPrintTime = '';
            this.receiptPromotionImageError = {officialAccount: false};
            this.paymentReceipt = {institutionName: null, patientName: null, patientAge: null, patientGender: null, prescriptionType: null, doseCount: null, receivedAmount: null, orderNo: null, paidAt: null, paymentMethod: null, promotion: null};
        },

        displayReceiptValue(value) {
            return value === null || value === undefined || value === '' ? '--' : value;
        },

        receiptInstitutionName(value) {
            return value === null || value === undefined || value === '' ? '知夏中医' : value;
        },

        formatReceiptGender(value) {
            return value === '0' || value === 0 ? '男' : value === '1' || value === 1 ? '女' : '未知';
        },

        formatReceiptPrescriptionType(value) {
            const prescriptionTypes = {
                0: '颗粒',
                1: '饮片',
                2: '膏方',
                3: '水丸'
            };
            return Object.prototype.hasOwnProperty.call(prescriptionTypes, value) ? prescriptionTypes[value] : '--';
        },

        formatReceiptPaymentMethod(value) {
            if (value === null || value === undefined || value === '') return '在线支付';
            const paymentMethod = String(value).trim();
            if (/微信|weixin|wechat/i.test(paymentMethod)) return '微信支付';
            if (/支付宝|alipay/i.test(paymentMethod)) return '支付宝';
            if (/银行卡|bank|card/i.test(paymentMethod)) return '银行卡';
            return paymentMethod;
        },

        formatReceiptAge(value) {
            return value === null || value === undefined || value === '' ? '--' : value + '岁';
        },

        formatReceiptAmount(value) {
            const amount = Number(value);
            return Number.isFinite(amount) ? '￥' + amount.toFixed(2) : '--';
        },


        handleReceiptPromotionImageError(type) {
            this.receiptPromotionImageError[type] = true;
            message("推广二维码加载失败，本次凭条不含该推广信息", "warning");
        },

        hasReceiptPromotion() {
            return !this.receiptPromotionImageError.officialAccount && officialAccountQrCode;
        },

        receiptOfficialAccountQrCode() {
            return officialAccountQrCode;
        },

        waitForReceiptPromotionImages() {
            const printArea = this.$refs.paymentReceiptPrintArea;
            if (!printArea || typeof printArea.querySelectorAll !== 'function') {
                return Promise.resolve();
            }
            const images = printArea.querySelectorAll('.receipt-promotion-list img');
            return Promise.all(Array.from(images).map(image => {
                if (image.complete) return Promise.resolve();
                return new Promise(resolve => {
                    image.addEventListener('load', resolve, {once: true});
                    image.addEventListener('error', resolve, {once: true});
                });
            }));
        },

        previewPaymentReceipt() {
            this.openPaymentReceipt(true);
        },

        printPaymentReceipt() {
            this.openPaymentReceipt(false);
        },

        openPaymentReceipt(preview) {
            if (this.receiptLoading || !this.medicalOrder.orderId) {
                if (!this.medicalOrder.orderId) message("未获取到订单信息，请重新进入订单详情后重试", "error");
                return;
            }
            this.receiptLoading = true;
            getMedicalOrderPaymentReceipt(this.medicalOrder.orderId).then(async response => {
                if (response.data.code !== 200 || !response.data.data) throw new Error(response.data.msg || '收款凭证数据获取失败');
                this.paymentReceipt = response.data.data;
                this.receiptPrintTime = this.getDayDateNow();
                this.receiptPromotionImageError = {officialAccount: false};
                await this.$nextTick();
                if (preview) {
                    this.receiptPreviewVisible = true;
                    return;
                }
                await this.waitForReceiptPromotionImages();
                this.$refs.paymentReceiptPrintButton.$el.click();
            }).catch(error => {
                console.error('门诊收款凭证打印失败:', error);
                const errorMessage = preview ? "收款凭证预览加载失败，请稍后重试" : "订单已支付，但收费小票打印失败，请检查打印机后重试";
                ElMessageBox.alert(errorMessage, "支付成功提醒", {
                    confirmButtonText: "知道了",
                    type: "warning"
                }).catch(() => {});
            }).finally(() => {
                this.receiptLoading = false;
            });
        },


        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
